import { ReportRow } from "./types";

function downloadCsv(content: string, filename: string) {
  const blob = new Blob([content], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function exportStCsv(rows: ReportRow[], reportDate: string) {
  const headers = [
    "Report Date: " + reportDate,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Contract Currency",
    "",
    "",
    "",
    "",
    "Functional Currency",
    "",
    "",
    "",
    "",
    "",
  ];
  const colHeaders = [
    "Contract",
    "Company Code",
    "Reseller ID",
    "Issuance Date",
    "Contract End Date",
    "Effort Type",
    "Total Fee",
    "Contract Currency Code",
    "Historical FX Rate",
    "Functional Currency Code",
    "ST Issuance",
    "(+) Reclassifications from LT",
    "(-) Invoices Issued",
    "(-) Write-offs",
    "(=) Ending Balance",
    "ST Issuance",
    "(+) Reclassifications from LT",
    "(-) Invoices Issued",
    "(-) Write-offs",
    "(+/-) FX Revaluation",
    "(=) Ending Balance",
  ];
  const csvRows = [headers.join(","), colHeaders.join(",")];
  for (const r of rows) {
    const fx = r.fxRate;
    csvRows.push(
      [
        r.fixedFeeId,
        r.companyCode,
        r.resellerId,
        r.dealStartDate,
        r.dealEndDate,
        r.automationStatus,
        r.contractPrice.toFixed(2),
        r.currencyCode,
        fx.toFixed(4),
        r.funcCurrency,
        r.stIssuance.toFixed(2),
        r.cumulativeReclass.toFixed(2),
        (-r.invoicesIssued).toFixed(2),
        "0.00",
        r.stEnding.toFixed(2),
        (r.stIssuance * fx).toFixed(2),
        (r.cumulativeReclass * fx).toFixed(2),
        (-r.invoicesIssued * fx).toFixed(2),
        "0.00",
        "0.00",
        (r.stEnding * fx).toFixed(2),
      ].join(","),
    );
  }
  downloadCsv(
    csvRows.join("\n"),
    `unbilled-ar-13003-short-term-${reportDate}.csv`,
  );
}

export function exportLtCsv(rows: ReportRow[], reportDate: string) {
  const headers = [
    "Report Date: " + reportDate,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Contract Currency",
    "",
    "",
    "",
    "Functional Currency",
    "",
    "",
    "",
    "",
  ];
  const colHeaders = [
    "Contract",
    "Company Code",
    "Reseller ID",
    "Issuance Date",
    "Contract End Date",
    "Effort Type",
    "Total Fee",
    "Contract Currency Code",
    "Historical FX Rate",
    "Functional Currency Code",
    "LT Issuance",
    "(-) Reclassifications to ST",
    "(-) Write-offs",
    "(=) Ending Balance",
    "LT Issuance",
    "(-) Reclassifications to ST",
    "(-) Write-offs",
    "(+/-) FX Revaluation",
    "(=) Ending Balance",
  ];
  const csvRows = [headers.join(","), colHeaders.join(",")];
  for (const r of rows) {
    const fx = r.fxRate;
    csvRows.push(
      [
        r.fixedFeeId,
        r.companyCode,
        r.resellerId,
        r.dealStartDate,
        r.dealEndDate,
        r.automationStatus,
        r.contractPrice.toFixed(2),
        r.currencyCode,
        fx.toFixed(4),
        r.funcCurrency,
        r.ltIssuance.toFixed(2),
        (-r.cumulativeReclass).toFixed(2),
        "0.00",
        r.ltEnding.toFixed(2),
        (r.ltIssuance * fx).toFixed(2),
        (-r.cumulativeReclass * fx).toFixed(2),
        "0.00",
        "0.00",
        (r.ltEnding * fx).toFixed(2),
      ].join(","),
    );
  }
  downloadCsv(
    csvRows.join("\n"),
    `unbilled-ar-18203-long-term-${reportDate}.csv`,
  );
}
